import { isMacLike } from "@/utils/platform";

/**
 * Whether the nudge should be shown based on platform, desktop context, and organization tier.
 */
export function showNudgeDownloadApp(isDesktop: boolean, tierEnabled: boolean, tierLoading: boolean): boolean {
    if (tierLoading || !tierEnabled) return false;
    if (isDesktop) return false;
    if (!isMacLike()) return false;
    return true;
}
